/**
 * Removes duplicate channels from the myHomeTeamChannels array.
 * @param {any[]} myHomeTeamChannels - The array of channels to filter.
 * @returns {any[]} - The filtered array with duplicates removed [removed duplicated Out-of-market RSN if In-market RSN is available].
 */
export const handleRemoveMyHomeTeamDuplicates = (myHomeTeamChannels: any[]): any[] => {
  const filteredChannels = {}
  myHomeTeamChannels?.forEach?.(channel => {
    if ((!filteredChannels?.[channel?.name || channel?.channelNameLabel || channel?.callSign] || (filteredChannels?.[channel?.name || channel?.channelNameLabel || channel?.callSign] && (channel?.category === "RSN" || channel?.categoryId === "RSN"))))
      // eslint-disable-next-line curly
      filteredChannels[channel?.name || channel?.channelNameLabel || channel?.callSign] = channel;
  });
  return Object?.values?.(filteredChannels);
}
